import { Box, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

const History = () => {
  const { mode } = useAppTheme()

  return (
    <Box sx={{ width: '100%', height: '100%', m: 0, p: 0 }}>
      <Typography
        sx={{
          color: mode === 'dark' ? '#BBD7FF' : '#003F61',
          textAlign: 'right',
          fontFamily: 'Rubik, sans-serif',
          fontSize: 'clamp(32px, 2.5vw, 48px)',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 1.2,
          marginTop: '63px',
          marginBottom: '45px',
          marginRight: '54px',
        }}
      >
        החלפות
      </Typography>
      <iframe
        src="https://reader.madrimonim.co.il/rmr/"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          display: 'block',
        }}
        title="History Frame"
      />
    </Box>
  )
}

export default History
